'use client'

import { Builder } from '@builder.io/react'

import { textStyleMap } from '../Builder/Text/Text'
import { SlidingText } from './SlidingText'
import { SlidingTextDefaultProps } from './SlidingText.defaults'

Builder.registerComponent(SlidingText, {
  name: 'SlidingText',
  inputs: [
    {
      name: 'items',
      friendlyName: 'Words',
      type: 'list',
      defaultValue: SlidingTextDefaultProps.items,
      subFields: [{ name: 'value', type: 'html' }],
    },
    {
      name: 'itemStyle',
      type: 'string',
      defaultValue: SlidingTextDefaultProps.itemStyle,
      enum: Array.from(Object.keys(textStyleMap)),
    },
    {
      name: 'itemColor',
      type: 'color',
      defaultValue: SlidingTextDefaultProps.itemColor,
    },
    {
      name: 'duration',
      friendlyName: 'Word duration (s)',
      type: 'number',
      defaultValue: SlidingTextDefaultProps.duration,
    },
    {
      name: 'speed',
      friendlyName: 'Animation transition speed (s)',
      type: 'number',
      defaultValue: SlidingTextDefaultProps.speed,
    },
  ],
  image: 'https://unpkg.com/@tabler/icons@2.44.0/icons/text-wrap.svg',
})
